import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Dialog } from "@mui/material";
import { Button, useDialog } from "common";
import I18n from "i18n";
import GroupEventCreateForm from "./GroupEventCreateForm";

export default function GroupEventCreateButton() {
  const [isOpen, setIsOpen, dialogProps] = useDialog();

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<CalendarMonthIcon />}
        onClick={() => setIsOpen(true)}
      >
        {I18n.t("Event.groupCreate.buttonLabel")}
      </Button>
      <Dialog {...dialogProps} maxWidth="xl" fullWidth>
        {isOpen && <GroupEventCreateForm onClose={() => setIsOpen(false)} />}
      </Dialog>
    </>
  );
}
